import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`This action sets, overwrites, or removes any existing `}<a parentName="p" {...{
          "href": "/api/../api/projects/custom-fields"
        }}>{`custom`}</a>{` field for an existing order `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setLineItemCustomField"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode>{` - String - Required`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`value`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/custom-fields#customfieldvalue"
          }}>{`CustomFieldValue`}</a>{` - Optional`}<br parentName="li"></br>
          {`If `}<inlineCode parentName="li">{`value`}</inlineCode>{` is absent or `}<inlineCode parentName="li">{`null`}</inlineCode>{`, this field will be removed if it exists. Trying to remove a field that does not exist will fail with an `}<a parentName="li" {...{
            "href": "/api/../api/errors#general-400-invalid-operation"
          }}>{`InvalidOperation`}</a>{` error.
If `}<inlineCode parentName="li">{`value`}</inlineCode>{` is provided, set the `}<inlineCode parentName="li">{`value`}</inlineCode>{` of the field defined by the `}<inlineCode parentName="li">{`name`}</inlineCode>{`.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      